// extracted by mini-css-extract-plugin
export var surveySessionQuestionList = "survey-session-question-list-module--survey-session-question-list--5Ib35";